import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=23028aa4&scoped=true&"
import script from "./Preferences.vue?vue&type=script&lang=js&"
export * from "./Preferences.vue?vue&type=script&lang=js&"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=23028aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23028aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23028aa4')) {
      api.createRecord('23028aa4', component.options)
    } else {
      api.reload('23028aa4', component.options)
    }
    module.hot.accept("./Preferences.vue?vue&type=template&id=23028aa4&scoped=true&", function () {
      api.rerender('23028aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Preferences.vue"
export default component.exports